import React from "react";
import { Link } from "react-router-dom";
import "./inner-pages.css";

export default function About({ t }) {
  return (
    <div className="inner-page">
      <section className="inner-page__intro">
        <div className="container inner-page__intro-grid">
          <div>
            <span className="inner-page__eyebrow">Italiano988 / {t("about")}</span>
            <h1>{t("about.title")}</h1>
            <p>{t("description")}</p>
            <Link className="inner-page__intro-link" to="/contact">{t("contact")} <span aria-hidden="true">↗</span></Link>
          </div>
          <div className="about-art" aria-hidden="true">
            <div className="about-art__orbit about-art__orbit--outer" />
            <div className="about-art__orbit about-art__orbit--inner" />
            <div className="about-art__line about-art__line--one" />
            <div className="about-art__line about-art__line--two" />
            <span className="about-art__node about-art__node--one" />
            <span className="about-art__node about-art__node--two" />
            <span className="about-art__node about-art__node--three" />
            <span className="about-art__center">I<span>988</span></span>
            <span className="about-art__caption">IMPORT / EXPORT / CONNECTION</span>
          </div>
        </div>
      </section>

      <section className="inner-page__body" aria-labelledby="about-values-title">
        <div className="container">
          <div className="inner-page__section-heading">
            <span className="inner-page__eyebrow">Italiano988 / 01</span>
            <h2 id="about-values-title">{t("about.valuesTitle")}</h2>
            <p>{t("about.valuesSubtitle")}</p>
          </div>
          <div className="row g-4">
            {t("features").map((feature, index) => (
              <div className="col-md-4" key={feature}>
                <article className="about-value">
                  <span className="about-value__index">0{index + 1}</span>
                  <span className="about-value__icon" aria-hidden="true">✦</span>
                  <h3>{feature}</h3>
                  <span className="about-value__line" />
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
